<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <div class="text-center mb-20">
          <h1>{{ headerData.title }}</h1>
          <div
            class="p-quote-blog-intro-text mt-16 mb:mt-20 mb-4 text-left md:text-center"
          >
            {{ headerData.intro_text }}
          </div>
          <div class="flex flex-col md:flex-row md:m-4 md:space-x-5 hidden">
            <input
              id="email-address"
              name="email"
              type="email"
              autocomplete="email"
              required
              class=""
              placeholder="Enter name, topic or keyword here…"
            />
            <BaseButton
              class="md:w-32 w-full h-[43px] text-blog-18 font-bold"
              text="Search"
            ></BaseButton>
          </div>
        </div>
      </NuxtLayout>

      <div class="bg-secondary-lighter py-8">
        <NuxtLayout name="center" v-if="topicLists.length > 0">
          <div class="md:m-4">
            <h2 class="text-center md:text-left mb-8">
              {{ $t("faq.topics") }}
            </h2>
            <CommonTopicCard :list="topicLists" card_type="faqs" />
          </div>
        </NuxtLayout>
        <NuxtLayout name="center">
          <CommonLiveChatBlock></CommonLiveChatBlock>
        </NuxtLayout>
      </div>
    </div>
  </div>
</template>

<script setup>
const headerData = ref();
const topicLists = ref([]);
const { data: faqIntro } = await useFaqIntro();
headerData.value = faqIntro.value.data;

const { data: topicData } = await useFaqTopicList();
topicLists.value = topicData.value.data;

useMetaTitles(headerData.value, "faqs");

const breadcrumbs = getBreadcrumbs("faqs");
</script>
